import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-checkbox-list',
  styles: `
    .checkbox-item {
      border-radius: var(--mar-border-radius-md, 12px);
      border: var(--border-width-thin, 1px) solid var(--border-secondary-default, #CFCFCF);
      background: var(--mar-foreground-secondary-default, #FFF);

      display: flex;
      padding: var(--mar-spacing-default-lg, 16px);
      align-items: center;
      gap: var(--mar-spacing-default-lg, 16px);

      margin-bottom: 12px;
      cursor: pointer;
      transition: background-color 0.2s ease;

      input[type="checkbox"] {
        display: none;
      }

      .checkbox-custom {
        width: 20px;
        height: 20px;
        border-radius: var(--mar-spacing-default-xs, 4px);
        border: var(--mar-border-width-thin, 1px) solid var(--mar-border-secondary-default, #CFCFCF);
        background: var(--mar-foreground-secondary-default, #F0F6FE);
        position: relative;
        flex-shrink: 0;
      }

      .label {
        color: var(--mar-text-tertiary, #4E4E4E);
        font-family: var(--mar-open-sans, "Open Sans"), sans-serif;
        font-size: var(--mar-font-size-14px, 14px);
        font-style: normal;
        font-weight: var(--mar-font-weight-500, 500);
        line-height: var(--mar-line-height-20px, 20px); /* 142.857% */
        letter-spacing: var(--mar-letter-spacing-0, 0px);
      }

      &.hovered {
        @media (min-width: 600px) {
          background: var(--mar-foreground-secondary-hover, #F0F6FE);
          border: var(--mar-border-width-thin, 1px) solid var(--mar-border-secondary-hover, #CFCFCF);
        }
      }

      &.checked {
        background: var(--mar-foreground-secondary-active, #E2ECFD);
        border: var(--mar-border-width-thin, 1px) solid var(--mar-border-secondary-active, #CFCFCF);

        .checkbox-custom {
          background: var(--mar-foreground-primary-default, #0B57D0);
          border-color: var(--mar-foreground-primary-default, #0B57D0);
        }

        .checkbox-custom::after {
          content: '';
          position: absolute;
          left: 6px;
          top: 2px;
          width: 6px;
          height: 12px;
          border: solid white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        .label {
          color: var(--mar-text-primary, #000);
          font-weight: var(--mar-font-weight-500, 500);
        }
      }
    }
  `,
  template: `
    @for (option of getOptions; track option; let i = $index) {
      <div class="checkbox-item"
        [class.checked]="formControl.value?.includes(option.value)"
        [class.hovered]="hoveredIndex === i"
        (mouseenter)="hoveredIndex = i"
        (mouseleave)="hoveredIndex = -1"
        (click)="toggleSelection(option.value)">
        <span class="checkbox-custom"></span>
        <span class="label">{{ option.label }}</span>
      </div>
    }
    `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyFieldCheckboxListComponent extends FieldType<FieldTypeConfig> {
  hoveredIndex = -1;

  get getOptions(): any[] {
    return !!this.props.options ? this.props.options as any[] : [];
  }


  toggleSelection(value: any): void {
    const current = this.formControl.value || [];
    const index = current.indexOf(value);

    if (index === -1) {
      this.formControl.setValue([...current, value]);
    } else {
      const updated = [...current];
      updated.splice(index, 1);
      this.formControl.setValue(updated);
    }

    this.formControl.markAsTouched();
  }
}
